import moment from 'moment';

export const generateMockSlots = () => {
  const slots = [];
  const today = moment();
  const times = [
    { timeFrom: '09:00', timeTo: '11:00' },
    { timeFrom: '11:00', timeTo: '13:00' },
    { timeFrom: '14:00', timeTo: '16:00' },
    { timeFrom: '16:00', timeTo: '18:00' },
    { timeFrom: '18:00', timeTo: '20:00' },
  ];

  for (let i = -5; i <= 60; i += 1) {
    const d = moment(today).add(i, 'days').format('YYYY-MM-DD');
    slots.push({
      date: d,
      isHoliday: false,
      availableSessions: times.map((t, idx) => ({
        session: `slot_${d}_${idx}`,
        timeFrom: t.timeFrom,
        timeTo: t.timeTo,
        totalAppoinmentCount: 5,
        availableAppoinmentCount: 5,
        totalStaffCount: 2,
        availableStaffCount: 2,
      })),
    });
  }
  return slots;
};

export const mockSlots = generateMockSlots();
export default mockSlots;
